import {ObjectUtils} from "../../../utils/data/ObjectUtils";
import {PopupWindowV5} from "./PopupWindowV5";
import type {IPopupWindowConfigV5} from "./PopupWindowV5";

/**
 * Can be used as an alternative for `prompt("alertMessage");`
 */
export class PromptWindowV5 extends PopupWindowV5<string | null> {
	protected static override readonly _defaultConfig: IPopupWindowConfigV5 = {
		ok: "Submit",
		cancel: "Cancel",
		backdrop: false,
		parentElement: document.body,
	};

	protected _okValue = "";
	protected _cancelValue: null = null;

	constructor(
		message: string,
		title: string,
		placeholder: string,
		defaultValue: string,
		config: IPopupWindowConfigV5 = {additionalElements: document.createElement("input")},
	) {
		super({
			title: title,
			message: message,
			config: ObjectUtils.mergeConfig(PromptWindowV5._defaultConfig, config),
		});

		this._config.additionalElements = document.createElement("input");
		this._config.additionalElements.classList.add("promptInput");
		(this._config.additionalElements as HTMLInputElement).placeholder = placeholder;
		(this._config.additionalElements as HTMLInputElement).value = defaultValue;
		this._okValue = defaultValue;
		this._config.additionalElements.oninput = this.onInputFieldChange;

		requestAnimationFrame(() => {
			if (this._config.additionalElements?.parentElement) {
				this._config.additionalElements.focus();
			}

			this.setOkButtonEnableState();
		});
	}

	private onInputFieldChange = (event: Event) => {
		this._okValue = (event.currentTarget as HTMLInputElement).value;

		this.setOkButtonEnableState();
	};

	private setOkButtonEnableState = () => {
		if (this._config.disableButtonOnEmptyInput) {
			if (!this._okValue) {
				this.disableOkButton();
			} else {
				this.enableOkButton();
			}
		}
	};

	public static open(message: string, title: string = "Submit", placeholder: string = "", defaultValue: string = "", config?: IPopupWindowConfigV5) {
		return new PromptWindowV5(message, title, placeholder, defaultValue, config).open() as Promise<string>;
	}
}
